import React, { useEffect, useState } from "react";
import "./App.css";
import Footer from "./components/Footer/Footer";
import Navbar from "./components/Navbar/Navbar";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Home from "./pages/home/Home";
import Product from "./pages/productInfo/Product";
// import Allproduct from "./pages/AllProduct/Allproduct";
import Signup from "./pages/registration/Signup";
import Login from "./pages/registration/Login";
// import UserDashboard from "./pages/user/UserDashboard";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AddProduct from "./pages/admin/AddProduct";
// import UpdateProduct from "./pages/admin/UpdateProduct";
import State from "./context/State";
import { Toaster } from "react-hot-toast";
import ContactUs from "./components/contactUs/Contact";
import RefundPolicy from "./components/Footer/footer-link/refund";
import TermsAndConditions from "./components/Footer/footer-link/termsAndConditions";
import FAQ from "./components/Footer/footer-link/faq";
import Privacy from "./components/Footer/footer-link/privacy";
import Warranty from "./components/Footer/footer-link/warranty";
import BlogPage from "./components/blog/Blog";
import Homeproduct from "./components/HomeProductCard/Homeproduct";
import ScrollToTop from "./components/ScrollToTop";
import About from "./components/about/AboutUs";
import ResortInfo from "./pages/resortinfo/ResortInfo";
import WhatsAppButton from "./components/HomeProductCard/Whatsapp";
import PhoneButton from "./components/HomeProductCard/Phone";
import ConsultationModal from "./components/modal/ConsultationModal";
import AOS from "aos";
import "aos/dist/aos.css";
import FeaturedResorts from "./components/HomeProductCard/FeaturedResorts";
import BlogDetails from "./components/blog/BlogDetails";
import PackagesPage from "./pages/packages/Packages";
import UpdateResort from "./pages/admin/updateResort";
import { ProtectedRouteForAdmin } from "./ProtectedRoute/Admin";

AOS.init();

function App() {
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpenModal(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <State>
        <BrowserRouter>
          <ConsultationModal
            isOpen={openModal}
            onClose={() => setOpenModal(false)}
          />

          <Navbar />
          <ScrollToTop />
          <WhatsAppButton />
          <PhoneButton />

          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/productinfo/:id" element={<Product />} /> */}
            <Route path="/resorts" element={<FeaturedResorts />} />
            <Route path="/resort/:id" element={<ResortInfo />} />
            <Route path="/resort/:id/packages" element={<PackagesPage />} />
            <Route path="/about" element={<About />} />
            {/* <Route path="/allproduct" element={<Allproduct />} /> */}
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/blogs" element={<BlogPage />} />
            <Route path="/blog/:id" element={<BlogDetails />} />

            {/* ✅ Direct Access (No Protection) */}
            {/* <Route path="/userDashboard" element={<UserDashboard />} /> */}
            <Route
              exact
              path="/adminDashboard"
              element={
                <ProtectedRouteForAdmin>
                  <AdminDashboard />
                </ProtectedRouteForAdmin>
              }
            />

            <Route
              path="/addproduct"
              element={
                <ProtectedRouteForAdmin>
                  <AddProduct />
                </ProtectedRouteForAdmin>
              }
            />
            <Route
              path="/updateResort/:id"
              element={
                <ProtectedRouteForAdmin>
                  <UpdateResort />
                </ProtectedRouteForAdmin>
              }
            />

            {/* Footer Links */}
            {/* <Route path="/refund-policy" element={<RefundPolicy />} /> */}
            <Route
              path="/termsAndConditions"
              element={<TermsAndConditions />}
            />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/warranty" element={<Warranty />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>

          <Footer />
        </BrowserRouter>

        <Toaster />
      </State>
    </div>
  );
}

export default App;
